import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'
import _ from 'lodash'
import DateRangePicker from 'react-bootstrap-daterangepicker'

import { useGetMutateCall } from '../../lib/api/get'
import { NoDataCard } from '../../common/NoDataCard'
import { Activities } from './Activities'

import 'bootstrap-daterangepicker/daterangepicker.css'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)

export const KidsAttendance = ({
  isLocalEnvironment,
  envData,
  routeData,
  authDetails,
  defaultData,
}) => {
  const [reportData, setReportData] = React.useState(null)
  const [accordion, setAccordion] = React.useState(null)
  const [openActivities, setOpenActivities] = React.useState(false)
  const [activityData, setActivityData] = React.useState(null)
  const getCallMutation = useGetMutateCall()

  const [selectedDates, setSelectedDates] = React.useState(null)

  const openActivity = (data) => {
    setOpenActivities(true)
    setActivityData(data)
  }

  const closeActivity = () => {
    setOpenActivities(false)
    setActivityData(null)
  }

  function getDates(startDate, endDate, steps = 1) {
    const dateArray = []
    let currentDate = new Date(startDate)

    while (currentDate <= new Date(endDate)) {
      dateArray.push(new Date(currentDate))
      // Use UTC date to prevent problems with time zones and DST
      currentDate.setUTCDate(currentDate.getUTCDate() + steps)
    }

    return dateArray
  }

  const onSearch = async (e, ind) => {
    e.preventDefault()
    const allDates = getDates(selectedDates.start, selectedDates.end)

    const dataRes = []
    defaultData.formData[ind].attendance.length > 0 &&
      defaultData.formData[ind].attendance.map((r) => {
        const elem = r
        elem['studentName'] = defaultData.formData[ind].studentName
        dataRes.push(elem)
      })
    const response = _.groupBy(dataRes, 'studentName')
    const reportSubs = []
    Object.entries(response).map((m) => {
      const isAttendance = []
      let isAtten = 0
      let checkIn, checkOut, activities, attendanceId
      m[1].map((m1) => {
        isAtten = 1
        checkIn = dayjs(m1.checkInDateTime).format('HH:mm')
        checkOut = dayjs(m1.checkOutDateTime).format('HH:mm')
        activities = m1.activities
        attendanceId = m1.attendanceId
        isAttendance.push({
          day: dayjs(m1.checkInDateTime).format('MM/DD'),
          atten: isAtten,
          checkIn,
          checkOut,
          activities,
          attendanceId,
          allDates,
        })
      })
      reportSubs.push({
        studentName: m[0],
        isAttendance,
      })
    })
    setReportData(reportSubs)
  }
  const openAccordion = (appInd) => {
    setReportData(null)
    setAccordion(appInd)
  }

  const handleCallback = (start, end) => {
    setSelectedDates({
      start: dayjs(start._d).format('YYYY-MM-DD'),
      end: dayjs(end._d).format('YYYY-MM-DD'),
    })
  }
  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div
            className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between"
            style={{ paddingTop: '1.3rem', paddingBottom: '1.3rem' }}
          >
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
          </div>
        </div>
      </div>

      <div className="trtui-row trtui-justify-content-center">
        <div className="trtui-col-12">
          <div className="trtui-card trtui-p-1">
            <div
              className="trtui-accordion trtui-custom-accordionwithicon trtui-custom-accordion-border trtui-accordion-border-box trtui-accordion-primary"
              id="accordionBordered"
            >
              {defaultData.formData.length > 0 ? (
                defaultData.formData.map((app, appInd) => (
                  <div key={`${accordion}${appInd}`} className="trtui-accordion-item">
                    <h2 className="trtui-accordion-header" id="accordionborderedExample1">
                      <button
                        className={`trtui-accordion-button ${accordion === appInd ? '' : 'trtui-collapsed'}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accor_borderedExamplecollapse1"
                        aria-expanded="true"
                        aria-controls="accor_borderedExamplecollapse1"
                        onClick={() => openAccordion(accordion === appInd ? null : appInd)}
                      >
                        {app.studentName}
                      </button>
                    </h2>
                    <div
                      id="accor_borderedExamplecollapse1"
                      className={`trtui-accordion-collapse trtui-collapse ${accordion === appInd ? 'trtui-show' : ''}`}
                      aria-labelledby="accordionborderedExample1"
                      data-bs-parent="#accordionBordered"
                    >
                      <div className="trtui-accordion-body">
                        <form onSubmit={(e) => onSearch(e, appInd)}>
                          <div className="trtui-row">
                            <div key="fromDate" className="trtui-col-md-10">
                              <label>Date Range</label>
                              <DateRangePicker onCallback={handleCallback}>
                                <input className="trtui-form-control" />
                              </DateRangePicker>
                            </div>
                            <div className="trtui-col-md-2" style={{ paddingTop: '1.7rem' }}>
                              <button
                                className="trtui-btn trtui-btn-icon trtui-btn-primary"
                                disabled={getCallMutation.isLoading}
                              >
                                {getCallMutation.isLoading ? (
                                  <span className="trtui-d-flex trtui-align-items-center">
                                    <span className="trtui-flex-grow-1 trtui-me-2"> </span>
                                    <span
                                      className="trtui-spinner-border trtui-flex-shrink-0"
                                      role="status"
                                    >
                                      <span className="trtui-visually-hidden"> </span>
                                    </span>
                                  </span>
                                ) : (
                                  <i className="ri-search-line" />
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                        <hr />
                        {accordion === appInd && reportData !== null && reportData.length > 0 ? (
                          reportData.map((rep, repInd) => (
                            <div
                              key={`${accordion}${appInd}${repInd}`}
                              className="trtui-table-responsive trtui-mt-4 trtui-mt-xl-0"
                            >
                              <table className="trtui-table trtui-table-hover trtui-table-striped trtui-align-middle trtui-table-nowrap trtui-mb-0">
                                <thead>
                                  <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Check-In</th>
                                    <th scope="col">Check-Out</th>
                                    <th scope="col">Activities</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rep.isAttendance.length > 0 &&
                                    rep.isAttendance.map(
                                      (d, dInd) =>
                                        d.atten === 1 && (
                                          <tr key={dInd}>
                                            <td className="trtui-fw-medium">
                                              {dayjs(d.day).format('YYYY-MM-DD')}
                                            </td>
                                            <td>
                                              {d.checkIn
                                                ? dayjs(`${d.day} ${d.checkIn}`).format('HH:mm A')
                                                : 'NA'}
                                            </td>
                                            <td>
                                              {d.checkOut
                                                ? dayjs(`${d.day} ${d.checkOut}`)
                                                    .utcOffset(480)
                                                    .format('HH:mm A')
                                                : 'NA'}
                                            </td>
                                            <td>
                                              {d.attendanceId ? (
                                                <i
                                                  title="View Activities"
                                                  onClick={() => openActivity(d.activities)}
                                                  className="ri-eye-line trtui-fs-17 trtui-lh-1 trtui-align-middle trtui-cursor-pointer"
                                                ></i>
                                              ) : (
                                                'NA'
                                              )}
                                            </td>
                                          </tr>
                                        ),
                                    )}
                                </tbody>
                              </table>
                            </div>
                          ))
                        ) : (
                          <NoDataCard />
                        )}
                        {openActivities && (
                          <Activities
                            isLocalEnvironment={isLocalEnvironment}
                            envData={envData}
                            authDetails={authDetails}
                            setOpenActivity={closeActivity}
                            modSchema={JSON.parse(routeData.apiEndPointSchema)}
                            childFormData={activityData[0]}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <NoDataCard />
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

KidsAttendance.propTypes = {
  isLocalEnvironment: PropTypes.string,
  envData: PropTypes.object,
  routeData: PropTypes.object,
  authDetails: PropTypes.object,
  defaultData: PropTypes.object,
}
